<template>
  <div>
    <search-input
      v-if="hasTemplates && !isAwaitTemplates"
      class="visit-service-table__search-input"
      label="Выберите шаблон"
      placeholder="Название шаблона"
      item-text="title"
      item-value="value"
      v-bind:items="optionsOfTemplates"
      v-on:input="onApplyTemplate"
      v-on:open-modal="onShowTreatmentPlanTemplateCategorySelectModal"
      v-bind:has-open-modal="true"
      v-bind:value="plan.templateId"
    />
    <div v-else-if="!hasTemplates && !isAwaitTemplates">
      <router-link
        class="visit-service-table__link"
        v-bind:to="{ name: 'ClinicPanelTreatmentPlanTemplateList' }"
      >
        Создайте шаблоны услуг
      </router-link>
    </div>
    <div class="visit-service-table">
      <div class="visit-service-table__head">
        <div class="visit-service-table__head__cell">Услуга</div>
        <div class="visit-service-table__head__cell">Зубы</div>
        <div class="visit-service-table__head__cell">Кол-во</div>
        <div class="visit-service-table__head__cell vhi">Цена</div>
        <div class="visit-service-table__head__cell vhi">Рекламация</div>
        <div class="visit-service-table__head__cell discount">
          Скидка
          <switch-discount-type
            v-bind:disabled="isDiscountChangeDisabled"
            v-bind:value="initialDiscountType"
            v-on:input="onInputDiscountType"
          />
        </div>
        <div class="visit-service-table__head__cell">Итого</div>
        <div class="visit-service-table__head__cell">Статус</div>
        <div
          class="visit-service-table__head__cell"
          v-if="canDelete" />
      </div>
      <div class="visit-service-table__body">
        <visit-service-table-row
          v-for="(item, index) in rows"
          v-bind:key="item.id || item.key"
          v-bind:amount-kop="item.amount.toKop()"
          v-bind:by-vhi-policy="item.byVHIPolicy"
          v-bind:can-change-discount="canChangeDiscount"
          v-bind:can-delete-positions="canDelete"
          v-bind:category-name="item.categoryName"
          v-bind:complaint="item.complaint"
          v-bind:cost="item.cost"
          v-bind:count="item.count"
          v-bind:dental-parts="item.dentalParts"
          v-bind:discount-type="item.discount.getType()"
          v-bind:discount-value="item.discount.getValue()"
          v-bind:errors-discount="errorsDiscount[index]"
          v-bind:formatted-final-price="item.finalPrice.getFormattedRub()"
          v-bind:is-milk-bite-default="isMilkBiteDefault"
          v-bind:only-view="onlyView || item.hasEditingRestrict"
          v-bind:service-name="item.serviceName"
          v-bind:teeth="item.teeth"
          v-bind:paid-status="item.paidStatus"
          v-bind:has-editing-restrict="item.hasEditingRestrict"
          v-on:delete="emitDelete(item)"
          v-on:input-by-vhi-policy="onInputByVhiPolicy(index, $event)"
          v-on:input-complaint="onInputComplaint(index, $event)"
          v-on:input-count="onInputCount(index, $event)"
          v-on:input-discount="onInputDiscount(index, $event)"
          v-on:input-teeth="onInputTeeth(index, $event)"
        />
      </div>
      <div v-if="isShowResult" class="visit-service-table__results">
        <p>
          Итого: <b>
            <the-rub
              v-bind:show-kop="$options.SHOW_KOP_AUTO"
              v-bind:kop="aggregateTotal.amount"
              currency="руб"
            />
          </b>
        </p>
        <p>
          Скидка:
          <input-total-discount
            v-bind:disabled="isDiscountChangeDisabled"
            v-bind:initial-discount-type="initialDiscountType"
            v-bind:initial-discount="aggregateTotal.discountWithoutFreeServices"
            v-bind:max-discount="aggregateTotal.amountWithoutFreeServices"
            v-bind:value="aggregateTotal.discount"
            v-on:change="onTotalDiscountChanged"
          />
        </p>
        <p>
          С учетом скидки: <b>
            <the-rub
              v-bind:show-kop="$options.SHOW_KOP_AUTO"
              v-bind:kop="aggregateTotal.final"
              currency="руб"
            />
          </b>
        </p>
      </div>
    </div>
    <modal-dialog
      title="Выберите шаблон"
      width="100%"
      max-width="350"
      with-cross
      v-model="isShowModalSelectTreatmentPlanCategory"
      v-on:on-click-outside="onCloseTreatmentPlanTemplateSelectTree"
    >
      <select-item-tree-dialog
        v-bind:fetch-children="getTreatmentPlanTemplateCategoryChildren"
        v-bind:items=treatmentsPlanTemplateCategoryTree
        v-on:change="onChangeSelectTreatmentPlanTemplate"
        v-on:created="getTreatmentPlanTemplateCategoriesTree"
      />
    </modal-dialog>
  </div>
</template>
<script>
import InputTotalDiscount from '@/components/InputTotalDiscount.vue';
import SwitchDiscountType from '@/components/SwitchDiscountType.vue';
import TheRub, { SHOW_KOP_AUTO } from '@/components/TheRub.vue';
import VisitServiceTableRow from '@/components/VisitServiceTableRow.vue';
import focusMixin from '@/mixins/focusMixin';
import spreadDiscountMixin from '@/mixins/spreadDiscountMixin';
import teethGroupMixin from '@/mixins/teethGroupMixin';
import SearchInput from '@/components/SearchInput.vue';
import { Plan } from '@/storage/gateways/PlanGateway';
import ModalDialog from '@/components/ModalDialog.vue';
import SelectItemTreeDialog from '@/components/SelectItemTreeDialog.vue';

/**
 * @description Название события изменения услуги.
 * @type {string}
 */
const NAME_EVENT_CHANGE_ROW = 'change';

/**
 * @description Название события добавления услуги.
 * @type {string}
 */
const NAME_EVENT_ADD_ROW = 'add';

/**
 * @description Название события очистить лист.
 * @type {string}
 */
const NAME_EVENT_CLEAN_LIST = 'clean-list';

/**
 * @description Название события удаления услуги.
 * @type {string}
 */
const NAME_EVENT_DELETED_ROW = 'delete';

/**
 * @description Название события ввода типа скидки.
 * @type {string}
 */
const NAME_EVENT_INPUT_DISCOUNT_TYPE = 'input-discount-type';

const EMPTY_ERRORS = [];

/**
 * @description Таблица услуг.
 * @type {any}
 */
export default {
  components: {
    SelectItemTreeDialog,
    ModalDialog,
    SearchInput,
    TheRub,
    VisitServiceTableRow,
    SwitchDiscountType,
    InputTotalDiscount,
  },
  SHOW_KOP_AUTO,
  data() {
    return {
      /**
       * @description Категории с дочерними шаблонами.
       * @type {Array}
       */
      treatmentsPlanTemplateCategoryTree: [],
      /**
       * @description Показывать модальное окно выбора шаблона в категориях.
       * @type {boolean}
       */
      isShowModalSelectTreatmentPlanCategory: false,
      /**
       * @description План.
       * @type {Plan}
       */
      plan: new Plan(),

      /**
       * @description Шаблоны.
       * @type {PlanTemplate[]}
       */
      templates: [],

      /**
       * @description Ожидание загрузки шаблонов.
       * @type {boolean}
       */
      isAwaitTemplates: true,

      /**
       * @description Шаблоны плана лечения.
       * @type {{id:number,name:string}[]}
       */
      planTemplates: [],

      /**
       * Был ли применен шаблон
       */
      templateWasApplied: false,
    };
  },
  async created() {
    this.fetchTreatmentPlanFillers();
  },
  computed: {
    /**
     * @description Имеются шаблоны.
     * @type {boolean}
     */
    hasTemplates() {
      return this.templates.length > 0;
    },

    /**
     * @description Варианты шаблонов.
     * @type {{title: string, value: string}[]}
     */
    optionsOfTemplates() {
      const templates = this.templates.map((template) => ({
        title: template.getName(),
        value: template.getId(),
      }));
      const planTemplates = this.planTemplates.map((template) => ({
        title: template.name,
        value: template.id,
      }));
      return [...templates, ...planTemplates];
    },

    /**
     * @description Может удалять услуги.
     * @type {boolean}
     */
    canDelete() {
      return this.canDeletePositions && !this.onlyView;
    },
    /**
     * @description Может менять общую скидку.
     * @type {boolean}
     */
    isDiscountChangeDisabled() {
      return !this.canChangeDiscount || this.onlyView;
    },
    /**
     * @description Показывать итоги.
     * @returns {boolean}
     */
    isShowResult() {
      return this.rows.length > 0;
    },
    /**
     * @description Суммарные итоги.
     * @returns {Object}
     */
    aggregateTotal() {
      const initial = {
        amount: 0,
        discount: 0,
        final: 0,
        amountWithoutFreeServices: 0,
        discountWithoutFreeServices: 0,
      };
      return this.rows.reduce(
        (total, service) => ({
          amount: total.amount + service.amount.toKop(),
          discount: total.discount + service.discountAmount.toKop(),
          final: total.final + service.finalPrice.toKop(),
          amountWithoutFreeServices: total.amountWithoutFreeServices
            + (service.isFullDiscounted ? 0 : service.amount.toKop()),
          discountWithoutFreeServices: total.discountWithoutFreeServices
            + (service.isFullDiscounted ? 0 : service.discountAmount.toKop()),
        }),
        initial,
      );
    },
    /**
     * @description Нарушения ограничений скидки.
     * @returns {string[][]}
     */
    errorsDiscount() {
      return this.rows.map((_, index) => {
        const violations = (this.violations || {})[index];
        if (violations) {
          return violations.discount || EMPTY_ERRORS;
        }
        return EMPTY_ERRORS;
      });
    },
  },
  methods: {
    /**
     * @description Обработать событие выбора шаблона плана лечения.
     * @param template
     * @returns {void}
     */
    onChangeSelectTreatmentPlanTemplate(template) {
      if (template) {
        this.onApplyTemplate(template.id);
      }
      this.onCloseTreatmentPlanTemplateSelectTree();
    },
    /**
     * @description Обработать событие закрытия дерева выбора шаблона.
     * @returns {void}
     */
    onCloseTreatmentPlanTemplateSelectTree() {
      this.isShowModalSelectTreatmentPlanCategory = false;
    },
    /**
     * @description Получить список категорий шаблонов плана лечения.
     * @returns {void}
     */
    async getTreatmentPlanTemplateCategoriesTree() {
      this.treatmentsPlanTemplateCategoryTree = this
        .treatmentsPlanTemplateCategories
        .map((item) => ({
          id: item.id,
          name: item.name,
          children: [],
        }));
    },
    /**
     * @description Получить шаблоны по категории.
     * @param {Object} item
     * @returns {void}
     */
    async getTreatmentPlanTemplateCategoryChildren(item) {
      const children = this
        .templates
        .filter((template) => template.getCategoryId() === item.id)
        .map((template) => ({
          id: template.getId(),
          name: template.getName(),
        }));
      item.children.push(...children);
    },
    /**
     * @description Обработать событие выбора
     * @returns {void}
     */
    onShowTreatmentPlanTemplateCategorySelectModal() {
      this.isShowModalSelectTreatmentPlanCategory = true;
    },
    /**
     * Очистить список услуг
     *
     * @return {void}
     */
    clearServiceList() {
      this.$emit(NAME_EVENT_CLEAN_LIST);
    },
    /**
     * @description Обработать применение шаблона к текущим услугам.
     * @param {number} templateId Идентификатор шаблона.
     * @returns {void}
     */
    onApplyTemplate(templateId) {
      if (this.plan.templateId === templateId) {
        return;
      }
      this.templates
        .flatMap((item) => (item.getId() === templateId ? [item] : []))
        .flatMap((item) => {
          const stages = item.getStages();
          if (stages.length > 0) {
            return stages.flatMap((stage) => stage.getServices());
          }
          this.plan = this.plan.applyTemplate(item);
          return item.getServices();
        })
        .forEach((service) => {
          const planService = {
            categoryName: service.getCategoryName(),
            name: service.getName(),
            cost: service.getPrice(),
            units: service.getUnits(),
            teeth: service.getTeeth(),
            count: service.getCount(),
            id: service.getId(),
          };
          this.$emit(NAME_EVENT_ADD_ROW, planService);
          this.templateWasApplied = true;
        });
    },
    /**
     * @description Получить данные для заполнения плана лечения.
     * @returns {void}
     */
    fetchTreatmentPlanFillers() {
      const onResponse = ({ templates }) => {
        this.templates = templates.filter((template) => !template.getHasTrashed());
        this.isAwaitTemplates = false;
      };
      this.$planGateway.viewTreatmentPlanFillers().then((result) => result.forEach(onResponse));
    },
    /**
     * @description Получить ключ.
     * @param {PositionProps} item
     * @param {number}        index
     * @returns {string}
     */
    getKey(item, index) {
      return `${index}-${JSON.stringify(item.getMeaningfulFields())}`;
    },
    /**
     * @description Отправить событие изменения услуги.
     * @param {number} index Номер строки.
     * @param {any}    value Строка.
     */
    emitChange(index, value) {
      this.$emit(NAME_EVENT_CHANGE_ROW, [index, value]);
    },
    /**
     * @description Отправить событие удаления услуги.
     * @param {Object} service Услуга.
     * @returns {void}
     */
    emitDelete(service) {
      this.$emit(NAME_EVENT_DELETED_ROW, service);
    },
    /**
     * @description Обработать ввод ДМС.
     * @param {number}  index
     * @param {boolean} value
     * @returns {void}
     */
    onInputByVhiPolicy(index, value) {
      const item = this.rows[index];
      this.emitChange(index, item.setByVhiPolicy(value));
    },
    /**
     * @description Обработать ввод рекламации.
     * @param {number}  index
     * @param {{complaint:boolean,byVhiPolicy:boolean}} event
     * @returns {void}
     */
    onInputComplaint(index, { complaint, byVhiPolicy }) {
      const item = this.rows[index];
      this.emitChange(index, item.setComplaint(complaint, byVhiPolicy));
    },
    /**
     * @description Обработать ввод количества.
     * @param {number} index
     * @param {number} value
     * @returns {void}
     */
    onInputCount(index, value) {
      const item = this.rows[index];
      this.emitChange(index, item.setCount(value));
    },
    /**
     * @description Обработать ввод скидки.
     * @param {number} index
     * @param {number} value
     * @returns {void}
     */
    onInputDiscount(index, value) {
      const item = this.rows[index];
      this.emitChange(index, item.setDiscount(item.discount.setValue(value)));
    },
    /**
     * @description Обработать ввод типа скидки.
     * @param {string} value
     * @returns {void}
     */
    onInputDiscountType(value) {
      this.$emit(NAME_EVENT_INPUT_DISCOUNT_TYPE, value);
    },
    /**
     * @description Обработать ввод зубов.
     * @param {number}   index
     * @param {{teeth:number[],dentalParts:Array}} event
     * @returns {void}
     */
    onInputTeeth(index, { teeth, dentalParts }) {
      const item = this.rows[index];
      this.emitChange(index, item.setTeeth(teeth, dentalParts));
    },
    /**
     * @description Обработать изменение общей скидки.
     * @returns {void}
     */
    onTotalDiscountChanged(value) {
      const rows = this.rows.filter((candidate) => !candidate.isFullDiscounted);
      if (rows.length > 0) {
        const discounts = this.spreadDiscount(
          this.initialDiscountType,
          value,
          rows,
          this.aggregateTotal.amountWithoutFreeServices,
        );
        rows.forEach((candidate, index) => {
          const rowIndex = this.rows.indexOf(candidate);
          const discount = candidate.discount.setValue(discounts[index]);
          this.emitChange(rowIndex, candidate.setDiscount(discount));
        });
      }
    },
  },
  mixins: [focusMixin, spreadDiscountMixin, teethGroupMixin],
  name: 'VisitServiceTable',
  props: {
    /**
     * @description Категории шаблонов планов лечения.
     * @type {Array<PlanCategory>}
     */
    treatmentsPlanTemplateCategories: { required: true, type: Array },
    /**
     * @description Может изменять скидки.
     * @type {boolean}
     */
    canChangeDiscount: { default: () => false, type: Boolean },
    /**
     * @description Может удалять позиции.
     * @type {boolean}
     */
    canDeletePositions: { default: () => false, type: Boolean },
    /**
     * @description Только просмотр.
     * @type {boolean}
     */
    onlyView: { default: () => false, type: Boolean },
    /**
     * @description Строки таблицы.
     * @type {Position[]}
     */
    rows: { required: true, type: Array },
    /**
     * @description Базовое состояние прикуса
     * @type {boolean}
     */
    isMilkBiteDefault: { default: () => false, type: Boolean },
    /**
     * @description Тип скидки.
     * @type {string}
     */
    initialDiscountType: { required: true, type: String },
    /**
     * @description Нарушения ограничений.
     * @type {Object}
     */
    violations: { default: () => {}, type: Object },
  },
};
</script>
<style lang="scss">
.visit-service-table {
  counter-reset: counterServices;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 0 0 20px 0;
  padding: 0 0 20px 0;
  &__search-input {
    max-width: 500px;
  }
  &__head,
  &__row {
    display: grid;
    grid-template-columns:
      minmax(195px, 1fr) 100px 75px
      120px 95px 175px 125px 120px 43px;
    align-items: center;
    font-size: 14px;
    line-height: 17px;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
    &__cell {
      padding: 12px 8px;
      cursor: default;
      &.vhi {
        justify-self: center;
      }
      &.discount {
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }
  }
  &__row {
    &.new {
      background: #eaeff3;
    }
    &.violation {
      border-color: var(--warning-color);
      .visit-service-table__cell__name {
        color: var(--warning-color) !important;
      }
    }
    border-bottom: 1px solid #eaeff3;
    &:hover:not(.no-hover) {
      background: #eaeff3;
    }
  }
  &__results {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-self: flex-end;
    margin: 28px 65px 0 0;
    p {
      font-weight: 700;
      font-size: 16px;
      line-height: 19px;
      color: #707683;
      b {
        color: #323c47;
      }
    }
  }
  &__unit {
    width: 100%;
  }
  &__cell {
    cursor: pointer;
    padding: 12px 8px;
    &:focus {
      border: 1px solid transparent !important;
      outline: 0;
    }
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
    &.number:after {
      counter-increment: counterServices;
      content: counter(counterServices);
    }
    &.discount {
      display: flex;
      align-items: center;
      margin-right: 35px;
      gap: 5px;
      & > input {
        background-color: white;
        border: 1px solid #0489e0 !important;
        border-radius: 4px;
        width: 100%;
        &:focus {
          color: #212529;
          border: 1px solid #0489e0;
          outline: 0;
        }
        &:disabled {
          color: #212529;
          cursor: default;
        }
      }
    }
    &.edit {
      background-color: white;
      border: 1px solid #0489e0 !important;
      border-radius: 4px;
      width: 100%;
      padding: 5px 8px;
      &.count {
        display: block;
        max-width: 36px;
        margin-inline: auto 25px;
      }
      &:focus {
        color: #212529;
        border: 1px solid #0489e0 !important;
        outline: 0;
      }
    }
    &.vhi {
      justify-self: center;
      & > span::before {
        margin: 0 !important;
      }
    }
    &.cost {
      width: 100%;
      display: flex;
      text-align: center;
      justify-content: center;
    }
    &.pointer {
      pointer-events: none;
    }
    &__color {
      width: 15px;
      height: 15px;
      border-radius: 50%;
    }
    &__name {
      text-align: left;
      cursor: default;
      padding: 12px 8px !important;
      margin: 0 !important;
      font-size: 16px;
      line-height: 24px;
      .v-input__control > .v-input__slot {
        cursor: pointer;
        &::before,
        &::after {
          border: none !important;
        }
        .v-select__slot > input {
          padding: 0 !important;
        }
      }
      .v-autocomplete__content {
        top: 45px !important;
      }
      & .v-list-item__title {
        white-space: pre-line;
      }
    }
    &.tooth {
      background-image: url("@/assets/img/tooth.svg");
      width: 100%;
      height: 30px;
      background-size: contain;
      margin-left: 12px;
      background-repeat: no-repeat;
    }
  }
  &__icon {
    &-copy {
      background-image: url("@/assets/img/copy-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/copy-blue.svg");
      }
    }
    &-edit {
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-delete {
      display: block;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
  }
  &__discount {
    &__input {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      & > input {
        width: 100%;
        &:focus {
          color: #212529;
          border-bottom: 1px solid #0489e0;
          outline: 0;
        }
        &:disabled {
          color: #212529;
          cursor: default;
        }
      }
    }
    &.editable {
      color: var(--action-color);
    }
  }
  &__link {
    display: flex;
    margin: 7px 0 0 0;
    &:hover {
      text-decoration: none;
    }
  }
}

@media screen and (max-width: 1560px) {
  .visit-service-table {
    overflow-x: auto;
    &__head,
    &__row {
      width: 100%;
      min-width: 1300px;
    }
  }
}

</style>
